import { useState } from "react";
import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { ALPHA__Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";
import ESI from "@JohnLewisPartnership/jl-esi-components";

interface Props {
  productId: string;
  variantId: string;
}

export function ExpressCheckoutUI({ productId, variantId }: Props) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const params = Object.entries({
    variantId,
    clientId: "web_pdp_scaffold_ui",
    enabled: "true",
    enableExpress: "true",
    showAddToBasket: "false",
  })
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  const src = `/esi/add-to-basket/${productId}/?${params}`;

  return (
    <>
      <PrimaryButton onClick={handleOpenDrawer}>Add to basket</PrimaryButton>

      <ALPHA__Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        header="Express Checkout"
        isDrawerLeft={false}
        isHeaderFixed={true}
        isNarrow={false}
        fullPage={true}
        rootId={"page-root"}
        isLegacySPDPDrawer={true}
      >
        <ESI src={src} id="express-checkout" />
      </ALPHA__Drawer>
    </>
  );
}
